var $ = (global.jQuery = require('jquery'));
var _ = require('underscore');
var Marionette = require('backbone.marionette');
require('lightgallery');
require('lightgallery/dist/js/lg-thumbnail');

var Gallery = Marionette.Behavior.extend({
    defaults: {
        gallerySelector: '[data-ui="gallery"]',
        openGallerySelector: '[data-ui="openGallery"]',
    },

    galleryIsRendered: false,

    ui: function() {
        return {
            openGallery: this.getOption('openGallerySelector'),
            gallery: this.getOption('gallerySelector'),
        };
    },

    events: {
        'click @ui.openGallery': 'openGallery',
    },

    defaultOptions: function() {
        return {
            mode: 'lg-fade',
            enableDrag: false,
            speed: 300,
            exThumbImage: 'data-thumbnail',
        };
    },

    getGalleryOptions: function() {
        var galleryOptions = this.getOption('galleryOptions');
        var options = _.isFunction(galleryOptions) ? _.bind(galleryOptions, this.view)() : galleryOptions;
        return _.extend({}, this.defaultOptions(), options);
    },

    onShow: function() {
        if (this.ui.gallery.length) {
            var options = this.getGalleryOptions();
            this.ui.gallery.lightGallery(options);
            this.galleryIsRendered = true;
        }
    },

    openGallery: function(e) {
        if (this.galleryIsRendered) {
            this.ui.gallery
                .data('lightGallery')
                .$items.first()
                .click();
        } else {
            var options = this.getGalleryOptions();
            var galleryEl = this.ui.gallery.length ? this.ui.gallery : $(e.target);
            galleryEl.lightGallery(options);
        }
    },
});

module.exports = Gallery;
